/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NazioneUpdateDTO
 */
export interface NazioneUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof NazioneUpdateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NazioneUpdateDTO
     */
    paeseCee?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NazioneUpdateDTO
     */
    codiceCee?: string | null;
}

/**
 * Check if a given object implements the NazioneUpdateDTO interface.
 */
export function instanceOfNazioneUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NazioneUpdateDTOFromJSON(json: any): NazioneUpdateDTO {
    return NazioneUpdateDTOFromJSONTyped(json, false);
}

export function NazioneUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NazioneUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'paeseCee': !exists(json, 'paeseCee') ? undefined : json['paeseCee'],
        'codiceCee': !exists(json, 'codiceCee') ? undefined : json['codiceCee'],
    };
}

export function NazioneUpdateDTOToJSON(value?: NazioneUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
        'paeseCee': value.paeseCee,
        'codiceCee': value.codiceCee,
    };
}

